import script from "./ProductChaptersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductChaptersPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductChaptersPage.vue?vue&type=style&index=0&id=321e6288&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321e6288"]])

export default __exports__